import { Editor, EditorState, convertToRaw, convertFromRaw, RichUtils } from "draft-js";
import React, { Component } from "react";
import { updateRanking } from "../../../../stores/actions/rankingAction";
import { compose } from "redux";
import { connect } from "react-redux";

class EditRankingInfo extends Component {
    constructor(props) {
        super(props);
        this.selectRef = React.createRef();
        this.state = {
            selectedRank: null,
            isLoading: null
        }
        this.baseState = this.state
    }

    loadSelectedRanking = () => {
        const { ranking, selectedRankId } = this.props;

        if (!ranking || !Array.isArray(ranking) || !selectedRankId) {
            this.setState({
                selectedRank: null
            });
            return
        }
        const selectedRank = ranking.find(rank => rank.id === selectedRankId);


        if (selectedRank) {

            let processedRank = { ...selectedRank };

            if (processedRank.action && Object.keys(processedRank.action).length > 0) {
                try {
                    const editorState = EditorState.createWithContent(
                        convertFromRaw(processedRank.action)
                    );
                    processedRank.action = editorState;

                    // const hasText = editorState.getCurrentContent().hasText();
                } catch (error) {
                    processedRank.action = EditorState.createEmpty();
                }
            } else {
                processedRank.action = EditorState.createEmpty();
            }
            this.setState({
                selectedRank: processedRank
            });
        } else {
            this.setState({
                selectedRank: null,
            })
        }
    }

    componentDidMount() {
        this.loadSelectedRanking();
    }

    componentDidUpdate(prevProps, prevState) {

        const { updateRankingSuccess, updateRankingError } = this.props;

        // console.log('component is mounted')
        if (prevProps.selectedRankId !== this.props.selectedRankId ||
            prevProps.ranking !== this.props.ranking) {
            this.loadSelectedRanking();//run loadSelectedRanking again when props changes(prevProps not same with current props)
        }

        if (prevProps.updateRankingError !== updateRankingError) {

            this.setState({
                isLoading: false,
                message: {
                    msg: updateRankingError.message,
                    type: updateRankingError.type
                }
            }, () => {
                window.alert('Ranking update error');
            })
        }

        if (prevProps.updateRankingSuccess !== updateRankingSuccess) {
            this.setState({
                isLoading: false,
                message: {
                    msg: updateRankingSuccess.message,
                    type: updateRankingSuccess.type
                }
            }, () => {
                window.alert('Ranking updated successfully');
                this.props.hideRankingModalEdit()
            })
        }
    }

    handleTitleChange = (event) => {
        this.setState(prevState => ({
            selectedRank: {
                ...prevState.selectedRank,
                title: event.target.value
            }
        }))
    }

    handlePercentageChange = (field) => (event) => {
        this.setState(prevState => ({
            selectedRank: {
                ...prevState.selectedRank,
                [field]: event.target.value,
            }
        }))
    }

    handleSchemeSelection = (event) => {
        const { schemes } = this.props;
        const selectedSchemeId = event.target.value;

        if (!selectedSchemeId) return;

        const selectedScheme = schemes.find(scheme => scheme.id === selectedSchemeId);

        if (!selectedScheme) return;

        const schemeSubset = {
            id: selectedScheme.id,
            name: selectedScheme.name,
            code: selectedScheme.code
        }

        this.setState(prevState => ({
            selectedRank: {
                ...prevState.selectedRank,//spread all of previously unaffected selectedQuestion
                selectedSchemes: [...(prevState.selectedRank.selectedSchemes || []), schemeSubset]//only this key is affected. spread also the previous data and then comma followed with updated data
            }
        }), () => {
            this.selectRef.current.value = "";
        });
    }

    handleSelectedSchemeDelete = (selectedSchemeId) => {
        this.setState(prevState => {
            const remainingSchemes = prevState.selectedRank.selectedSchemes.filter(
                scheme => scheme.id !== selectedSchemeId
            );

            return {
                selectedRank: {
                    ...prevState.selectedRank,
                    selectedSchemes: remainingSchemes
                }
            }
        })
    }

    handleDescriptionChange = (event) => {
        this.setState(prevState => ({
            selectedRank: {
                ...prevState.selectedRank,
                description: event.target.value
            }
        }))
    }

    handleActionChange = (newEditorState) => {
        this.setState(prevState => ({
            selectedRank: {
                ...prevState.selectedRank,
                action: newEditorState
            }
        }))
    }

    _onBoldClick = (editorState, changeHandler) => {
        changeHandler(RichUtils.toggleInlineStyle(editorState, 'BOLD'));
    }

    _onItalicClick = (editorState, changeHandler) => {
        changeHandler(RichUtils.toggleInlineStyle(editorState, 'ITALIC'));
    }

    _onUnderlineClick = (editorState, changeHandler) => {
        changeHandler(RichUtils.toggleInlineStyle(editorState, 'UNDERLINE'));
    }

    handleKeyCommand = (command, editorState, changeHandler) => {
        const newState = RichUtils.handleKeyCommand(editorState, command);
        if (newState) {
            changeHandler(newState);
            return 'handled';
        }
        return 'not-handled';
    }

    updateRanking = () => {
        const { selectedRank } = this.state;

        const {
            action,
            description,
            id,
            maxPercentage,
            minPercentage,
            selectedSchemes,
            title
        } = selectedRank

        const updatedRanking = {
            action: action ? convertToRaw(selectedRank.action.getCurrentContent()) : null,
            description,
            id,
            maxPercentage,
            minPercentage,
            selectedSchemes,
            title
        }

        this.props.updateRanking(updatedRanking, id);
    }

    render() {
        const { selectedRank } = this.state;
        const { ranking, schemes } = this.props;


        const filteredRankScheme = (schemes && selectedRank && selectedRank.selectedSchemes)
            ? schemes.filter(scheme =>
                !selectedRank.selectedSchemes.some(selected => selected.id === scheme.id)
            )
            : [];

        // console.log('props', this.props);
        // console.log('state', this.state);
        return (
            <div>
                {selectedRank ? (
                    <div>
                        <div className="uppercase middle"><span> Editing <b>{selectedRank.title}</b> Info</span>
                            <div className="title-border"></div>
                        </div>
                        <p>
                            <b>Title</b>
                            <input type="text" className="form-control" value={selectedRank.title} onChange={this.handleTitleChange} />
                        </p>
                        <div>
                            <b>Select related scheme:</b>
                            <select ref={this.selectRef} className="form-control" onChange={this.handleSchemeSelection}>
                                <option value="">Choose related scheme&#40;s&#41;</option>
                                {
                                    filteredRankScheme.map(scheme => (
                                        <option key={scheme.id} value={scheme.id}>
                                            {scheme.name}&#40;{scheme.code}&#41;
                                        </option>
                                    ))
                                }
                            </select>
                            <b>Selected Schemes</b>
                            {
                                selectedRank.selectedSchemes && selectedRank.selectedSchemes.map((selectedScheme, index) => (
                                    <div key={selectedScheme.id} className="d-flex justify-content-between">
                                        <div style={{ position: 'relative', left: '20px' }}>{selectedScheme.name} &#40;{selectedScheme.code}&#41;</div>
                                        <span onClick={() => this.handleSelectedSchemeDelete(selectedScheme.id)}><i className="fa fa-trash text-red"></i></span>
                                    </div>
                                ))
                            }
                        </div>
                        <div>
                            <b>Min Percentage</b>
                            <input
                                type="number"
                                className="form-control"
                                value={selectedRank.minPercentage}
                                onChange={this.handlePercentageChange('minPercentage')} />
                        </div>
                        <div>
                            <b>Max Percentage</b>
                            <input
                                type="number"
                                className="form-control"
                                value={selectedRank.maxPercentage}
                                onChange={this.handlePercentageChange('maxPercentage')} />
                        </div>
                        <div>
                            <b>Action</b>
                            <div style={{ backgroundColor: '#eeeeee', padding: '10px' }}>
                                <div className="col-md d-flex align-items-center justify-content-start" style={{ marginBottom: '10px', paddingBottom: '5px' }}>
                                    <button
                                        type="button"
                                        onMouseDown={(e) => e.preventDefault()}
                                        onClick={() => this._onBoldClick(selectedRank.action, this.handleActionChange)}
                                        style={{
                                            fontWeight: selectedRank.action.getCurrentInlineStyle().has('BOLD') ? 'bold' : 'normal',
                                            marginRight: '5px',
                                            padding: '5px 10px',
                                            border: '1px solid #ccc',
                                            backgroundColor: selectedRank.action.getCurrentInlineStyle().has('BOLD') ? '#e6f3ff' : 'white',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <strong>B</strong>
                                    </button>
                                    <button
                                        type="button"
                                        onMouseDown={(e) => e.preventDefault()}
                                        onClick={() => this._onItalicClick(selectedRank.action, this.handleActionChange)}
                                        style={{
                                            fontStyle: selectedRank.action.getCurrentInlineStyle().has('ITALIC') ? 'italic' : 'normal',
                                            marginRight: '5px',
                                            padding: '5px 10px',
                                            border: '1px solid #ccc',
                                            backgroundColor: selectedRank.action.getCurrentInlineStyle().has('ITALIC') ? '#e6f3ff' : 'white',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <em>I</em>
                                    </button>
                                    <button
                                        type="button"
                                        onMouseDown={(e) => e.preventDefault()}
                                        onClick={() => this._onUnderlineClick(selectedRank.action, this.handleActionChange)}
                                        style={{
                                            textDecoration: selectedRank.action.getCurrentInlineStyle().has('UNDERLINE') ? 'underline' : 'normal',
                                            marginRight: '5px',
                                            padding: '5px 10px',
                                            border: '1px solid #ccc',
                                            backgroundColor: selectedRank.action.getCurrentInlineStyle().has('UNDERLINE') ? '#e6f3ff' : 'white',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <u>U</u>
                                    </button>
                                </div>
                                <div style={{ border: '1px solid #ccc', minHeight: '50px', padding: '10px', flexGrow: 1, backgroundColor: 'white' }}>
                                    <Editor
                                        editorState={selectedRank.action}
                                        onChange={this.handleActionChange}
                                        handleKeyCommand={(command) => this.handleKeyCommand(command, selectedRank.action, this.handleActionChange)}
                                        placeholder="Action">
                                    </Editor>
                                </div>
                            </div>
                        </div>
                        <div>
                            <b>Description</b>
                            <textarea type="text" className="form-control" value={selectedRank.description} onChange={this.handleDescriptionChange}></textarea>
                        </div>
                        <div className="mt-5 row justify-content-end">
                            <button className="btn m-2 btn-outline-black" onClick={this.updateRanking}><i className="fas fa-plus-circle" />{' '}Update Ranking</button>
                        </div>
                    </div>
                ) : (
                    <div>No Data</div>
                )}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        updateRankingSuccess: state.ranking.updateRankingSuccess,
        updateRankingError: state.ranking.updateRankingError
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateRanking: (updatedRanking, rankingId) => dispatch(updateRanking(updatedRanking, rankingId))
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(EditRankingInfo)